import { createUseStyles } from 'react-jss';

import { Transition } from '../../../styles';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles<string, { spacing: number }>(
  ({ spacing }: ITheme) => ({
    root: {
      position: 'relative',
      width: '100%',
      height: '400px',
      overflow: 'hidden',
      paddingBottom: spacing.large,
    },
    page: {
      position: 'absolute',
      width: '100%',
      height: '100%',

      display: 'flex',
      flexDirection: 'column',

      touchAction: 'none',
      padding: spacing.large,
    },
    image: {
      flex: 1,
      touchAction: 'none',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      width: '100%',
    },
    content: {
      userSelect: 'none',
      touchAction: 'none',
    },
    activeIndicatorBack: {
      height: '2px',
      width: `calc(100% - ${spacing.large} * 2)`,
      background: 'var(--x-bg-3)',
      margin: `0 ${spacing.large}`,
    },
    activeIndicatorFront: {
      height: '100%',
      transition: `margin-left ${Transition.Default} ease-in-out`,
    },
  }),
  { name: 'image-carousel' },
);

export default useStyles;
